import React, { useEffect, useState } from 'react';
import '../style/docs.css';
import Docs from '../component/Docs';
import { ButtonComponent } from '../component/Common';
import api from "../utils/api";
import Swal from 'sweetalert2';
import { useLocation, useNavigate, useParams } from "react-router-dom";

function UploadDocument({onPriviousPage}) {
    const navigate = useNavigate();
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [isDataLoad, setisDataLoad] = useState(false);
    const [fileData, setFileData] = useState()
    const [uploadDocs, setUploadDocs] = useState({
        passportId: '',
        drivingLicenceId: '',
        utilityBill: '',
        employed: '',
        selfEmployed: '',
        bankStatement: '',
        awardLetter: '',
        mortgageStatments: '',
        proofOfDebits: '',
        creditReports: '',
        brokerFee: '',
    });

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get('applicationId');

    const documentsList = [
        { title: "UK PASSPORT ID", desc: "(If not a British Passport - then all Visa Pages are Required)", name: 'passportId' },
        { title: "DRIVING LICENCE ID", desc: '', name: 'drivingLicenceId' },
        { title: 'UTILITY BILL', desc: 'bills only dated within last 3 months OR Annual Council Tax Bill', name: 'utilityBill' },
        { title: 'EMPLOYED', desc: '3 Months LATEST payslips & Latest P60', name: 'employed' },
        { title: 'SELF EMPLOYED', desc: "3 Years LATEST SA302's AND 3 Years Tax Overviews", name: 'selfEmployed' },
        { title: 'BANK STATEMENTS', desc: '3 Months LATEST Bank Statements showing where SALARY is credited & House Bills are paid from', name: 'bankStatement' },
        { title: 'BENEFITS AWARD LETTER', desc: 'showing benefits credited (Working Tax Credit, Child Tax Credit, Child Benefit, etc)', name: 'awardLetter' },
        { title: 'MORTGAGE STATEMENT', desc: 'Show ALL Existing Mortgages', name: 'mortgageStatments' },
        { title: 'PROOF OF DEPOSIT', desc: 'If Proof of Deposit Bank Statement has Transfers of £1,000+ then evidence of amount is required', name: 'proofOfDebits' },
        { title: 'CREDIT REPORTS', desc: '', name: 'creditReports' },
        { title: 'BROKER FEE AGREED', desc: '(details on fee agreement) signed by client(s)', name: 'brokerFee' },
    ];

    // Handle file selection and conversion to Base64
    const onChangeFile = (name, file) => {
        if (!file) {
            return;
        }

        const allowedTypes = ["application/pdf", "image/png", "image/jpeg"];
        if (!allowedTypes.includes(file.type)) {
            setUploadDocs((prevData) => ({
                ...prevData,
                [`${name}-error`]: "Only PDF, PNG, and JPG files are allowed."
            }));
            return;
        }

        setUploadDocs((prevData) => {
            const newErrors = { ...prevData };
            delete newErrors[`${name}-error`];
            return newErrors;
        });

        // Store the actual file object
        setFileData((prevData) => ({
            ...prevData,
            [name]: file,
        }));

        // Update uploadDocs for display
        setUploadDocs((prevData) => ({
            ...prevData,
            [name]: file.name,
        }));
    };

    const formattedKeys = (data) => {
        const lowerWithSpaces = data.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
        return lowerWithSpaces.charAt(0).toUpperCase() + lowerWithSpaces.slice(1);
    };

    const validateForm = async () => {
        var isValid = true;
        for (const key in uploadDocs) {
            if (uploadDocs.hasOwnProperty(key)) {
                const value = uploadDocs[key];
                if (value == '') {
                    isValid = false;
                    var name = await formattedKeys(key);
                    setUploadDocs((prevData) => ({
                        ...prevData,
                        [`${key}-error`]: `${name}  document is required`
                    }));
                }
            }
        }
        return isValid;
    };

    const handleGoBack = () => {
        onPriviousPage()
    };

    const handleFormSubmission = async () => {
        try {
            if (!(await validateForm())) {                
                return;
            }

            const formData = new FormData();

            // Append files to the FormData
            if (fileData && Object.keys(fileData).length > 0) {
                Object.entries(fileData).forEach(([key, file]) => {
                    if (file) {
                        formData.append(key, file); // Append each file
                    }
                });
            }
            // Send data to the API
            const result = await api.post(`/upload-docs/${id}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            if (result.status === 200) {
                Swal.fire({
                    icon: "success",
                    title: result.data.message,
                    iconColor: '#008000',
                    showConfirmButton: false,
                    timer: 2000
                });
                navigate(`/form_preview?applicationId=${id}`);
            }
        } catch (error) {
            console.error("Post API error:", error);
        }
    };

    const saveFormData = async () => {
        try {
            const formData = new FormData();
            if (fileData && Object.keys(fileData).length > 0) {
                Object.entries(fileData).forEach(([key, file]) => {
                    if (file) {
                        formData.append(key, file);
                    }
                });
            } else {
                Swal.fire({
                    icon: "warning",
                    title: "No files to save",
                    text: "Please upload at least one file before saving.",
                    iconColor: '#FFA500',
                });
                return;
            }

            const result = await api.post(`/upload-docs/${id}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            if (result.status === 200) {
                Swal.fire({
                    icon: "success",
                    title: "Your documents have been saved successfully",
                    iconColor: '#008000',
                    showConfirmButton: true,
                    showCancelButton: true,
                    confirmButtonText: 'Exit ',
                    confirmButtonColor: '#0E2F4F',
                    cancelButtonText: 'Stay on Page',
                }).then(async (response) => {
                    if (response.isConfirmed) {
                        navigate('/mortgage_dashboard');
                    }
                });
            }
        } catch (error) {
            console.error("Post API error:", error);
        }
    };

    useEffect(() => {
        if (isInitialLoad) {
            setUploadDocs((prevData) => {
                const resetData = { ...prevData };
                for (const key in resetData) {
                    if (key.endsWith('-error')) {
                        resetData[key] = '';
                    }
                }
                return resetData;
            });
            setIsInitialLoad(false);
        } else {
            fetchDocumentsData(id)
        }
    }, [isInitialLoad]);

    const fetchDocumentsData = async (id) => {
        try {
            const result = await api.get(`/get-upload-docs/${id}`);
            const data = result.data;
            if (data) {
                for (const key in uploadDocs) {
                    if (data.hasOwnProperty(key)) {
                        const value = data[key];
                        if (value !== '') {
                            setUploadDocs((prevData) => ({
                                ...prevData,
                                [`${key}`]: `${value}`.split('-').slice(1).join('-')
                            }));
                        }
                    }
                }
            }
            setisDataLoad(true)
        } catch (error) {
            setisDataLoad(true)
        }
    }

    return (
        <>
            <div className="personal-details-form">
                <div className="docs_container">
                    <div className="form_name">Upload Documents
                        <p>
                            All documents are required before the broker to submit the application
                            <span className="required">*</span>
                        </p>
                    </div>
                    <div className="upload-documents-page">
                        {isDataLoad == true && documentsList.map((doc, index) => (
                            <Docs
                                key={index}
                                title={doc.title}
                                desc={doc.desc}
                                name={doc.name}
                                id={index}
                                onChange={onChangeFile}
                                file={uploadDocs[doc.name]}
                                error={uploadDocs[`${doc.name}-error`]}
                            />
                        ))}
                    </div>
                </div>
                <div className="buttons-style">
                    <div className="back-btn"><ButtonComponent name="Back" onClick={handleGoBack} /></div>
                    <div className="button-div">
                        <ButtonComponent name='Save & Exit' onClick={saveFormData} />
                        <ButtonComponent label="Submit" name='Submit' onClick={handleFormSubmission} />
                    </div>
                </div>
            </div>
        </>
    );
}

export default UploadDocument;